import { render, staticRenderFns } from "./PremiumShowcase.vue?vue&type=template&id=76243545&scoped=true&"
import script from "./PremiumShowcase.vue?vue&type=script&lang=js&"
export * from "./PremiumShowcase.vue?vue&type=script&lang=js&"
import style0 from "./PremiumShowcase.vue?vue&type=style&index=0&id=76243545&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76243545",
  null
  
)

export default component.exports